import RichText from "@components/RichText";
import Form, { useForm, Select, Switch, FormMaker } from "@components/Form";
import { Input, InputNumber, Card, Button, Row, Col, Alert } from "antd";
import api from "@api";
import { useNavigate } from "react-router-dom";
import { useUrlQuery, useMount } from "@hooks";
import { useRef, useState } from "react";
import { pick } from "@utils/field";
import uface from "@widget/uface";
const { Field } = FormMaker;
function getDeepIDs(data, valueName) {
	return data.reduce((accu, cur) => {
		accu.push(cur[valueName]);
		if (cur.children && cur.children.length > 0)
			accu.push(...getDeepIDs(cur.children, valueName));
		return accu;
	}, []);
}
export default () => {
	const [{ id }] = useUrlQuery();
	const navigate = useNavigate();
	const [formInstance] = useForm();
	const submit = (e, files) => {
		if (id)
			api["Solution/editSolution"]({ data: { id, ...e }, files }).then(
				(res) => {
					if (res.result) navigate("/solution/index");
				},
			);
		else
			api["Solution/addSolution"]({ data: e, files }).then((res) => {
				if (res.result) navigate("/solution/index");
			});
	};
	useMount(() => {
		if (id)
			api["Solution/getSolutionDetail"]({ data: { id } }).then((detail) => {
				formInstance.setFields(
					pick(
						detail,
						"solution_name",
						"solution_intro",
						"sort",
						"content",
						"seo_title",
						"seo_keyword",
						"seo_descrip",
						({
							id,
							solution_img_full,
							solution_sml_full,
							type_id,
							is_hot,
						}) => ({
							is_hot: Number(is_hot),
							type_id: Number(type_id),
							"coverImg[]": solution_img_full
								? [{ path: solution_img_full, id }]
								: null,
							"solution_sml[]": solution_sml_full
								? [{ path: solution_sml_full, id }]
								: null,
						}),
					),
				);
			});
	});
	return (
		<Card>
			<Form
				form={formInstance}
				submitter={{ container: ".admin-box" }}
				onCancel={() => uface.jump()}
				onSubmit={submit}
			>
				<Form.Item title="所属类别" name="type_id">
					<Select
						request="Solution/getSolutionTypeList"
						labelName="type_name"
						valueName="id"
					></Select>
				</Form.Item>
				<Form.Item required title="标题" name="solution_name">
					<Input placeholder="请输入标题"></Input>
				</Form.Item>
				<Form.Item required title="简介" name="solution_intro">
					<Input.TextArea autoSize={{ minRows: 6 }}></Input.TextArea>
				</Form.Item>
				<Form.Item title="热门" name="is_hot">
					<Switch activeValue={1} inActiveValue={2} />
				</Form.Item>
				<Field
					title="封面图(大)"
					name="coverImg[]"
					valueType="upload:image"
					limit={1}
					onDelete={(d, del) => {
						uface
							.showModal({
								title: "警告",
								content: "确定要删除吗?",
								icon: "warning",
							})
							.then((confirm) => {
								if (confirm)
									api["Solution/delSolutionImg"]({ data: { id: d.id } }).then(
										(res) => {
											if (res.result) del();
										},
									);
							});
					}}
				></Field>
				<div
					style={{ width: "50vw", marginBottom: "20px", marginLeft: "80px" }}
				>
					<Alert message="大图尺寸：640*200" type="success" />
				</div>
				<Field
					title="封面图(小)"
					name="solution_sml[]"
					valueType="upload:image"
					limit={1}
					onDelete={(d, del) => {
						uface
							.showModal({
								title: "警告",
								content: "确定要删除吗?",
								icon: "warning",
							})
							.then((confirm) => {
								if (confirm)
									api["Solution/delSolutionSml"]({ data: { id: d.id } }).then(
										(res) => {
											if (res.result) del();
										},
									);
							});
					}}
				></Field>
				<div
					style={{ width: "50vw", marginBottom: "20px", marginLeft: "80px" }}
				>
					<Alert message="小图尺寸：173*126" type="success" />
				</div>
				<Form.Item title="排序" name="sort">
					<InputNumber placeholder="请输入排序"></InputNumber>
				</Form.Item>

				<Form.Item required title="内容" name="content">
					<RichText></RichText>
				</Form.Item>
			</Form>
		</Card>
	);
};
